import { inject, Injectable } from '@angular/core';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { map, shareReplay } from 'rxjs/operators';
import { PageConfigName, PageConfigModel } from '@bo-client/shared/models/userBackOfficeSettings';
import { Observable } from 'rxjs';

// Todo: Soll irgendwann die ganzen User Einstellungen verwalten (aus DataShareService auslagern)
@Injectable({
  providedIn: 'root'
})
export class UserConfigService {
  private dataShareService = inject(DataShareService);
  userConfigs$ = this.dataShareService.userConfiguration$.pipe(takeUntilDestroyed(), shareReplay(1));

  pageConfig = {
    get$: (page: PageConfigName): Observable<PageConfigModel | null> =>
      this.userConfigs$.pipe(map((configs) => (configs?.pageConfigs && configs.pageConfigs[page]) || null)),
    getSnapshot: (page: PageConfigName): PageConfigModel | null =>
      (this.dataShareService.currentUserConfiguration?.pageConfigs &&
        this.dataShareService.currentUserConfiguration.pageConfigs[page]) ||
      null,
    update: (data: Partial<PageConfigModel>, page: PageConfigName) => {
      const previousConfig =
        (this.dataShareService.currentUserConfiguration?.pageConfigs &&
          this.dataShareService.currentUserConfiguration.pageConfigs[page]) ||
        {};
      this.dataShareService.savePageConfig(page, {
        ...previousConfig,
        ...data
      });
    },
    updateMultiple: (data: {
      [key in PageConfigName]?: Partial<PageConfigModel>;
    }) => {
      const currentConfigs = this.dataShareService.currentUserConfiguration?.pageConfigs || {};
      const newConfigs: { [key in PageConfigName]?: PageConfigModel } = {};
      for (const page in data) {
        const pageKey = page as PageConfigName;
        newConfigs[pageKey] = {
          ...currentConfigs[pageKey],
          ...data[pageKey]
        };
      }
      this.dataShareService.saveMultiplePageConfigs(newConfigs);
    },
    replace: (data: PageConfigModel, page: PageConfigName) =>
      this.dataShareService.savePageConfig(page, data),
    clear: (page: PageConfigName) => this.dataShareService.savePageConfig(page, {})
  };
}
